import React from "react";
import {ResultManagerLabelUIProvider} from "./ResultManagerLabelUIContext";
import AddResultManagerLabel from "./AddResultManagerLabel";

export function ResultManagerLabelPage() {
  return (
    <ResultManagerLabelUIProvider>
      <AddResultManagerLabel />
    </ResultManagerLabelUIProvider>
  );
}
